import { request } from '@saasplatform/api';
import { clearAuthSession } from '@saasplatform/auth';
import type {
  AuthResponse,
  AuthResponseUser,
  LoginParams,
  RefreshTokenParams,
  RegisterParams,
} from '@saasplatform/saas-core';

export type {
  AuthResponse,
  AuthResponseUser,
  LoginParams,
  RefreshTokenParams,
  RegisterParams,
} from '@saasplatform/saas-core';

// 登录
export const login = (params: LoginParams): Promise<AuthResponse> => {
  return request.post('/auth/login', params);
};

// 注册
export const register = (params: RegisterParams): Promise<AuthResponse> => {
  return request.post('/auth/register', params);
};

// 刷新token
export const refreshToken = (params: RefreshTokenParams): Promise<AuthResponse> => {
  return request.post('/auth/refresh', params);
};

// 获取当前用户信息
export const getCurrentUser = (): Promise<AuthResponseUser> => {
  return request.get('/users/profile');
};

// 登出
export const logout = async () => {
  try {
    await request.post('/auth/logout');
  } finally {
    clearAuthSession();
  }
};
